// export const baseUrl: any = "https://res-api-dev.kolotsart.com/";
export const baseUrl: any = "https://api.haodymadagascar.com/"; 
export const imgPath: any = "https://api.haodymadagascar.com/";
// export const baseUrl: any = "http://localhost:3001/"; 
// export const imgPath: any = "http://localhost:3001/";
// export const mockeUrl: any = "http://localhost:5000/";&& && && 